import React from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../layouts/MainLayout";
import Form from "../../../components/forms/Form";
import { userProfileFields } from "../../../constants/forms/userProfileFields";
import useLoader from "../../../hooks/useLoader";
import useForm from "../../../hooks/useForm";
import {
  normalizeFormErrors,
  setDefaultFieldValues,
} from "../../../utils/objectUtils";
import useBaseService from "../../../hooks/services/useBaseService";
import { entities } from "../../../constants/entities";
import PageHeader from "../../../components/PageHeader";
import SectionHeader from "../../../components/forms/SectionHeader";
import SimpleBody from "../../../components/forms/SimpleBody";
import { useMutation } from "@tanstack/react-query";
import useNotification from "../../../hooks/useNotification";
import useUrlFilters from "../../../hooks/useUrlFilters";
import { useQueryClient } from "@tanstack/react-query";

const CreateUserPage = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const { formData, handleChange, resetForm } = useForm(
    setDefaultFieldValues(userProfileFields),
    userProfileFields
  );
  const { post: baseServicePost, formErrors } = useBaseService(navigate);
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

  const { filters, pagination } = useUrlFilters(
    {
      id: [],
      name: [],
      username: [],
      email: [],
      deleted_at: false,
    },
    "users"
  );

  const createUserMutation = useMutation({
    mutationFn: async () => {
      showLoader();
      const response = await baseServicePost(entities.users.create, formData);
      return response;
    },
    onSuccess: (response) => {
      if (response?.status === 200) {
        resetForm();
        hideLoader();
        navigate("/aluguel/usuarios");
        queryClient.invalidateQueries({
          queryKey: ["users", filters, pagination],
        });
      }
      hideLoader();
    },
    onError: (error) => {
      console.error("onError ", error);
      hideLoader();
    },
  });

  const handleSubmit = async () => {
    try {
      await createUserMutation.mutateAsync(formData);
    } catch (error) {
      console.error("Erro ao cadastrar usuário:", {
        status: error.status,
        message: error.message,
      });
    }
  };

  const handleBack = () => {
    navigate("/aluguel/usuarios");
  };

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Cadastro de Usuário"
        showBackButton={true}
        backUrl="/aluguel/usuarios"
      />
      <div className="container-fluid p-1">
        <Form
          onSubmit={handleSubmit}
          textSubmit="Cadastrar Usuário"
          initialFormData={formData}
          textLoadingSubmit="Cadastrando..."
          handleBack={handleBack}
        >
          {() => {
            const renderedSections = new Set();

            return userProfileFields.map((section, index) => {
              const sectionType = section.section.split(" - ")[0];
              const showHeader = !renderedSections.has(sectionType);

              if (showHeader) {
                renderedSections.add(sectionType);
              }

              return (
                <div key={section.section + " " + index}>
                  {showHeader && (
                    <SectionHeader
                      section={section.section}
                      viewTable={false}
                      setViewTable={() => {}}
                      addFieldsInData={() => {}}
                    />
                  )}

                  <SimpleBody
                    fields={section.fields}
                    formErrors={normalizeFormErrors(formErrors)}
                    formData={formData}
                    handleFieldChange={handleChange}
                    getOptions={() => {}}
                    getSelectedValue={() => {}}
                  />
                </div>
              );
            });
          }}
        </Form>
      </div>
    </MainLayout>
  );
};

export default CreateUserPage;
